import template from 'product-list-messages.j2';

import { mDom } from '../../../core/js/utils/renderUtils';

import { generate } from '../../../core/js/utils/componentUtils';
import { onStateChange } from '../utils/productComponentUtils';

export function init(store, overrides = {}) {
    const config = {
        templateLocation: '.dom-pdp .dom-main-product .dom-product-list-messages',
        watch: ['product.productListMessages'],
        template: template,
        name: 'productMessagesListComponent',
        replace: false,
        forFamilyProduct: false,
        onStateChange: onStateChange,
        renderType: mDom
    };

    return generate(config, store, overrides);
}
